import { JsonValue } from '@mainstage/types';
import { UIOptionsType } from '@rjsf/utils';
import { DateTime } from 'luxon';

export const DEFAULT_DATE_DISPLAY_FORMAT = 'dd/MM/yyyy';

export type DatePickerOptions = UIOptionsType & {
  dateDisplayFormat?: string;
};

export function getDateDisplayFormat(options?: DatePickerOptions): string {
  return options?.dateDisplayFormat ?? DEFAULT_DATE_DISPLAY_FORMAT;
}

export function dateToString(value: JsonValue | Date | undefined): string {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}(?:$|T)/.test(value))
    return '';

  const date = DateTime.fromISO(value, { setZone: true });
  return date.isValid ? date.toFormat('yyyy-MM-dd') : '';
}
